var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndie(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 30 30",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".indie-cls-1{fill:#eaeaea;}.indie-cls-2{fill:#878787;}.indie-cls-3{fill:#444;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Indie"
  }, /*#__PURE__*/React.createElement("circle", {
    className: "indie-cls-1",
    cx: 15,
    cy: 15,
    r: 15
  }), /*#__PURE__*/React.createElement("path", {
    className: "indie-cls-2",
    d: "M15,1A14,14,0,1,1,1,15,14,14,0,0,1,15,1m0-1A15,15,0,1,0,30,15,15,15,0,0,0,15,0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "indie-cls-3",
    d: "M13.58,19.87a.36.36,0,0,1-.26-.11.34.34,0,0,1-.12-.27v-9a.34.34,0,0,1,.12-.26.36.36,0,0,1,.26-.11h2.84a.36.36,0,0,1,.26.11.34.34,0,0,1,.12.26v9a.34.34,0,0,1-.12.27.36.36,0,0,1-.26.11Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "indie-cls-3",
    d: "M19.87,10.21a.39.39,0,0,1-.11.27.37.37,0,0,1-.27.11h-9a.36.36,0,0,1-.26-.11.39.39,0,0,1-.11-.27V7.38a.39.39,0,0,1,.11-.27A.36.36,0,0,1,10.5,7h9a.37.37,0,0,1,.27.11.39.39,0,0,1,.11.27Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "indie-cls-3",
    d: "M19.87,22.62a.39.39,0,0,1-.11.27.37.37,0,0,1-.27.11h-9a.36.36,0,0,1-.26-.11.39.39,0,0,1-.11-.27V19.79a.39.39,0,0,1,.11-.27.36.36,0,0,1,.26-.11h9a.37.37,0,0,1,.27.11.39.39,0,0,1,.11.27Z"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndie);
export default __webpack_public_path__ + "static/media/Indie.a9dc8066ad74bdae7f4c691edbc212a9.svg";
export { ForwardRef as ReactComponent };